import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-slate-950 text-slate-400 py-8 px-6 text-center text-sm border-t border-white/5" data-id="element-40">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-41">
        <p data-id="element-42">
          &copy; {new Date().getFullYear()} juicyonthebeach.com. All rights
          reserved.
        </p>
        <p data-id="element-43">Owned and operated by José, Web Developer.</p>
      </div>
    </footer>;
};